<template>
  <div v-if="!mobileCheck()">
    <PageHeader/>
    <Header/>
    <router-view class="Content"/>
    <Footer></Footer>
  </div>
  <div v-else>
    <Header/>
    <router-view class="mcontent"/>
    <Footer/>
  </div>
</template>


<script>
  import { mobileCheck } from '@/utils/common';
  import Header from './Header';
  import Footer from './Footer';
  import PageHeader from './PageHeader';

  export default {
    name: 'Layout',
    components: {
      Header,
      Footer,
      PageHeader,
    },
    data() {
      return {
        screenWidth: window.screen.width,
      };
    },
    methods: {
      mobileCheck() {
        return mobileCheck();
      },
    },
  };
</script>

<style>
.Content{
  padding-bottom: 60px;
}
.mcontent{
  width: 3.75rem;
  margin: 0 auto;
}
</style>
